import React, { useState, memo } from 'react';
import { Image } from 'react-native';
import { Box, Skeleton } from 'native-base';

interface LazyImageProps {
  source: { uri: string };
  style?: any;
  onLoad?: () => void;
  onError?: () => void;
}

const LazyImage: React.FC<LazyImageProps> = memo(({ source, style, onLoad, onError }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
    onLoad?.();
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
    onError?.();
  };

  if (hasError) {
    return (
      <Box
        style={style}
        justifyContent="center"
        alignItems="center"
        bg="gray.100"
      >
        <Box bg="red.100" p={2} borderRadius="md">
          <Box w="4" h="4" bg="red.400" />
        </Box>
      </Box>
    );
  }

  return (
    <Box style={style}>
      {isLoading && (
        <Skeleton
          style={style}
          startColor="coolGray.100"
          endColor="coolGray.300"
        />
      )}
      <Image
        source={source}
        style={[style, { opacity: isLoading ? 0 : 1 }]}
        onLoad={handleLoad}
        onError={handleError}
      />
    </Box>
  );
});

export default LazyImage;